import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";

export function OrderConfirmationPage() {
    const { state } = useLocation();

    if (!state?.orderNumber) return <Navigate to="/" replace />;

    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-lg mx-auto px-6 text-center">
                <CheckCircle size={48} strokeWidth={1} className="mx-auto mb-8 text-stone-400" />
                <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">
                    Thank you
                </p>
                <h1 className="font-serif text-5xl font-light italic mb-6">Order Confirmed</h1>
                <p className="text-stone-500 font-light leading-relaxed mb-3">
                    Your order{" "}
                    <span className="text-stone-900 font-medium">{state.orderNumber}</span>{" "}
                    has been received. A confirmation will be sent to your email shortly.
                </p>
                <p className="text-stone-400 text-sm font-light leading-relaxed mb-12">
                    Orders are processed within 1–2 business days. You'll receive a tracking number once your order ships.
                </p>
                <Link
                    to="/collection"
                    className="inline-block border border-stone-900 px-10 py-4 text-sm uppercase tracking-widest hover:bg-stone-900 hover:text-white transition-colors"
                >
                    Continue Shopping
                </Link>
            </div>
        </div>
    );
}
